import TableCellEmpty from './TableCellEmpty';
import { TableCell } from '@/components/ui';
import { cn } from '@/lib/utils';
import dayjs from 'dayjs';

type TProps = {
  className?: string;
  format?: string;
  date?: Date;
}

export const DataTableBodyCellDate = ({ date, className, format = 'DD/MM/YYYY hh:mm:ss' }: TProps) => (
  <TableCell className={cn('py-1 w-44 text-sm text-muted-foreground', className)}>
    {
      date
        ? dayjs(date).format(format)
        : <TableCellEmpty text='Non défini' />
    }
  </TableCell>
);

export default DataTableBodyCellDate;
